import React from "react";
import { formatMessage } from "lib/globalize-util";
import { AlertDialog } from "components/dialog";
import { styles } from "./styles";
import { UPCUploaderProvider } from "./context-api/provider";
import { UploaderUPC } from "./uploader-upc";

interface IProps {
    onClose: () => void;
}

export const ImportCollectionUpcDialog: React.FC<IProps> = ({ onClose }) => {
    return (
        <AlertDialog
            dismissButton={false}
            onRequestClose={onClose}
            open={true}
            title={<h4 style={styles.dialogTitle}>{formatMessage("Import UPCs")}</h4>}
            contentStyle={styles.dialogContainer}
        >
            <UPCUploaderProvider>
                <UploaderUPC />
            </UPCUploaderProvider>
        </AlertDialog>
    );
};
